import * as React from "react";

import { stripToWeek } from "../utils/date";

import { Day } from "./Day";
import { Weekday, Weekdays } from "./Resources/Weekdays";

export interface IWeekProps extends React.Props<Week> {
    day: Date;
    endDate?: Date;
    excludeDates?: Date[];
    filterDate?: (d: Date) => boolean;
    excludeWeekends?: boolean;
    maxDate?: Date;
    minDate?: Date;
    month?: number;
    onDayClick?: (d: Date) => void;
    selected?: Date;
    startDate?: Date;
}

export class Week extends React.Component<IWeekProps, any> {
    public render(): JSX.Element {
        return <tr className="week-row">{this.renderDays()}</tr>;
    }
    private handleDayClick(day: Date): void {
        if (this.props.onDayClick) {
            this.props.onDayClick(day);
        }
    }
    
    private excludeWeekends(excludeWeekends: boolean): Date[] {
        if(excludeWeekends) {
            const startOfWeek = stripToWeek(this.props.day);

            return [
                new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + Weekday.Sunday),
                new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + Weekday.Saturday)
            ];
        }

        return [];
    }

    private renderDays(): JSX.Element[] {
        const startOfWeek = stripToWeek(this.props.day);
        const excludeDates = [...(this.props.excludeDates ?? []), ...this.excludeWeekends(this.props.excludeWeekends)];

        return Weekdays.map((weekDay: number) => {
            const day = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + weekDay);
            const isOutside = this.props.month !== undefined && this.props.month !== day.getMonth();
            return (
                <td aria-hidden={isOutside} key={weekDay}>
                    <Day
                        day={day}
                        month={this.props.month}
                        onDayClick={(d: Date) => this.handleDayClick(d)}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        excludeDates={excludeDates}
                        filterDate={this.props.filterDate}
                        selected={this.props.selected}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                        notTabbable={isOutside}
                    />
                </td>
            );
        });
    }
}
